import {Headings} from "@arctheme-components/elements/Headings/Headings";
import {QuantityField} from "@arctheme-components/elements/Quantity/Quantity";
import { TextField } from "@src/stories/elements/TextField/TextField";
import {TextArea} from "@arctheme-components/elements/TextArea/TextArea";
import {SelectField} from "@arctheme-components/elements/Select/SelectField";
import {Checkbox} from "@arctheme-components/elements/Checkbox/Checkbox";

const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' }
]

export default function StyleguideFormFields() {
    const stylguideTestIcon = 'search-bold';

  return (
    <div className={'styleguide-components'}>

      <div className={'component-header mb-2'}>
        <Headings text={'Text Input'} type={'h2'} />
      </div>

      <div className={'flex items-center gap-8'}>
        <div className={'component grow'}>
          <TextField  id={1} type="floating-input" placeholder="Placeholder" label="Placeholder" />
        </div>
      </div>

      <div className={'flex items-center gap-8'}>
        <div className={'component grow'}>
          <TextField
            type="floating-input" 
            placeholder="Placeholder"
            label="Placeholder"
            id={2}
            labelRight={'Subscribe'}
          />
        </div>
      </div>

      <div className={'flex items-center gap-8'}>
        <div className={'component grow'}>
          <TextField
            type="floating-input"
            placeholder="Placeholder"
            errorMessage="Error message placeholder"
            hasError
            label="Placeholder"
          />
        </div>
      </div>

      <div className={'flex items-center gap-8'}>
        <div className={'component grow'}>
          <TextField
            placeholder="Placeholder"
            label="Placeholder"
            id={3}
            iconRight={'help-circle'}
          />
        </div>
      </div>

      <div className={'flex items-center gap-8'}>
        <div className={'component grow'}>
          <TextField
            placeholder="Placeholder"
            label="Placeholder"
            id={3}
            iconRight={'help-circle'}
            iconLeft={'credit-card'}
          />
        </div>
      </div>

      <div className={'flex items-center gap-8'}>
        <div className={'component grow'}>
          <TextField
            placeholder="Placeholder"
            label="Placeholder"
            id={3}
            iconRight={'help-circle'}
            iconLeft={'credit-card'}
            hasError
          />
        </div>
      </div>


      <div className={'flex items-center gap-8'}>
          <div className={'component grow'}>
            <div className={'component grow'}>
              <TextArea placeholder="Type your message..." />
            </div>
          </div>
      </div>

     
   
      <div className={'component-header mb-2'}>
        <Headings text={'Others'} type={'h2'} />
      </div>



      <div className={'flex items-center gap-8'}>
        <div className={'min-w-[150px] shrink-0'}>
          <h5>Dropdown</h5>
        </div>

        <div className={'component grow'}>
          <SelectField
            options={options}
            placeholder="Select one..."
          />
        </div>
      </div>

      <div className={'flex items-center gap-8'}>
        <div className={'min-w-[150px] shrink-0'}>
          <h5>Checkbox</h5>
        </div>

        <div className={'component'}>
          <Checkbox label={'Checkbox'} />
        </div>
      </div>

      <div className={'flex items-center gap-8'}>
        <div className={'min-w-[150px] shrink-0'}>
          <h5>Quantity Field</h5>
        </div>

        <div className={'component'}>
          <QuantityField />
        </div>
      </div>

   
    </div>
  )
}